import React from 'react';
import { ShieldCheckIcon, BadgeCheckIcon, DownloadIcon, LockIcon, HeadphonesIcon } from 'lucide-react';
export function TrustBar() {
  const features = [{
    icon: ShieldCheckIcon,
    text: 'Pago Seguro'
  }, {
    icon: BadgeCheckIcon,
    text: 'Garantía 45 Días'
  }, {
    icon: DownloadIcon,
    text: 'Descarga Inmediata'
  }, {
    icon: LockIcon,
    text: 'Protección de Datos'
  }, {
    icon: HeadphonesIcon,
    text: 'Soporte'
  }];
  return <section className="py-8 px-4 bg-brand-green text-brand-cream" data-id="element-187">
      <div className="max-w-5xl mx-auto" data-id="element-188">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12" data-id="element-189">
          {features.map((feature, index) => {
          const Icon = feature.icon;
          return <div key={index} className="flex flex-col items-center gap-2 text-center w-24 md:w-32" data-id="element-190">
                <Icon className="w-8 h-8 text-brand-gold" data-id="element-191" />
                <span className="text-sm font-medium" data-id="element-192">{feature.text}</span>
              </div>;
        })}
        </div>
      </div>
    </section>;
}